import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import { DocumentsManager, NotificationManager } from '@atlas/core';
import { onUploadDocumentSubmit, PREDEFINED_FORMS } from '@atlas/react-forms';
import { HeaderTitle, Label } from '@atlas/ui';

import FormMobile from 'common/Form/FormMobile';

const UploadForm = ({ documentTypes }) => {
  const uploadDocumentForm = useMemo(
    () => PREDEFINED_FORMS.uploadDocumentForm(documentTypes),
    [documentTypes],
  );

  const submitHandler = useCallback(({ verificationStatus }) => {
    const isUploaded = verificationStatus === 'UPLOADED';

    if (isUploaded) {
      NotificationManager.notify({
        message: 'upload_file_toast_title',
        status: 'success',
        type: 'notification',
      });
    }
  }, []);

  const uploadAction = onUploadDocumentSubmit((...args) =>
    DocumentsManager.uploadDocument(...args),
  );

  return (
    <div className="verify-form-container">
      <HeaderTitle className="sub-text block-medium">
        <span className="header-title__name">1.&nbsp;</span>
        <Label className="header-title__name" message="select_type_of_document" />
      </HeaderTitle>
      <FormMobile
        action={uploadAction}
        buttonText="upload"
        className="upload"
        form={uploadDocumentForm}
        onSubmit={submitHandler}
      />
    </div>
  );
};

UploadForm.propTypes = { documentTypes: PropTypes.arrayOf(PropTypes.string).isRequired };

export default UploadForm;
